webpackJsonp([49578089949595],{

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.RefKarriere = exports.SiteTitle = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _gatsbyImage = __webpack_require__(49);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _slugify = __webpack_require__(17);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import Img from 'gatsby-image'
	var BaseHref = 'http://46.4.51.11:1337';
	
	var JobPage = function JobPage(_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        'div',
	        { className: 'jobs' },
	        _react2.default.createElement(
	            'h1',
	            null,
	            'Karriere'
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-12 left' },
	                _react2.default.createElement(
	                    'ul',
	                    null,
	                    _react2.default.createElement(
	                        'div',
	                        null,
	                        data.allStrapiStellenangebote.edges.map(function (document) {
	
	                            var isPublic = document.node.Public;
	                            var jobs = void 0;
	
	                            if (isPublic == 0) {
	
	                                jobs = '';
	                            } else {
	                                jobs = _react2.default.createElement(
	                                    'li',
	                                    { key: document.node.id },
	                                    _react2.default.createElement(
	                                        'h3',
	                                        { className: 'jobtitle' },
	                                        'Zur Verst\xE4rkung unseres Teams am Arbeitsort ',
	                                        _react2.default.createElement(
	                                            'strong',
	                                            null,
	                                            document.node.Job_Location
	                                        ),
	                                        ' suchen wir eine/n'
	                                    ),
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/karriere/' + (0, _slugify.slugify)(document.node.Title) + '-' + (0, _slugify.slugify)(document.node.Job_Location) },
	                                        _react2.default.createElement(
	                                            'h2',
	                                            null,
	                                            document.node.Title
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'a',
	                                        { href: document.node.Job_Download.publicURL, target: '_blank' },
	                                        'Download PDF'
	                                    )
	                                );
	                            }
	                            return jobs;
	                        })
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'col-md-6 col-xs-12 right', style: { position: "relative" } },
	                _react2.default.createElement(_gatsbyImage2.default, {
	                    sizes: data.karriere.sizes,
	                    style: {
	                        position: "absolute",
	                        left: 0,
	                        bottom: 0,
	                        width: "80%",
	                        height: "100%"
	                    }
	                }),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'karriere-header' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'Wir freuen uns \xFCber Ihre'
	                    ),
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'mailto:bewerbung@boleygeotechnik.de?subject=Initiativbewerbung' },
	                            'Initiativbewerbung'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'an ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'mailto:bewerbung@boleygeotechnik.de?subject=Initiativbewerbung' },
	                            'bewerbung@boleygeotechnik.de'
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = JobPage;
	var SiteTitle = exports.SiteTitle = "Karriere";
	
	var RefKarriere = exports.RefKarriere = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-karriere-js-2e8a355a9843113f6c87.js